import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
// models
import { Answer } from '../models/answer';
import { SensorField } from '../models/sensor-field';
// services
import { OnlineStatusService, OnlineStatusType } from 'ngx-online-status';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {
  // network
  browser                 : string = "";
  public connectionStatus : string;
  public status           : boolean;
  public status_sub       : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(navigator.onLine);
  offline_mode_available  : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  offline_answers         : Array<any> = [];

  constructor(private onlineStatusService: OnlineStatusService, private http: HttpClient) {
    // Initialize status with current navigator.onLine value
    this.status = navigator.onLine;
    this.status_sub.next(navigator.onLine);
    
    this.status_sub.subscribe((value) => {
      this.status = value;
    })
    
    this.initStatusMonitor();
    // Force initial status check
    setTimeout(() => this.checkInitialStatus(), 0);
  }
  
  // Force initial status check
  private checkInitialStatus() {
    this.onlineStatusService.status.subscribe((status: OnlineStatusType) => {
      this.status_sub.next(status == 1);
    });
  }
  // start observe network status
  initStatusMonitor() {
    this.onlineStatusService.status.subscribe((status: OnlineStatusType) => {
      // Retrieve Online status Type
      // console.log("status", status);
      this.status_sub.next(status == 1);
    });
  }
  // Manual method to force status update
  public forceStatusUpdate() {
    const currentStatus = navigator.onLine;
    this.status_sub.next(currentStatus);
    return currentStatus;
  }
  // update local answers
  updateLocalData(sensor_id: number, answers: Array<Answer>, sensor_fields: Array<SensorField>) {
    // console.log('trabajar en el modo offiline para almacenar las respuestas');
    // localStorage.setItem("offline-"+ sensor_id +"-answers", JSON.stringify(data));
  }
  // return status value
  getStatus() {
    return this.status;
  }
  /**
   * get client ip
   */
  async getIP() {
    try {
      return await firstValueFrom(this.http.get<{ ip: string }>('https://api.ipify.org/?format=json'));
    } catch {
      return { ip: crypto.randomUUID() };
    }
  }
  /**
   * add a new answer to list of survey answers
   * @param hash 
   * @param answers 
   * @param sensor_form 
   */
  addAnswer(hash: string, answers: any, sensor_form?: any) {
    const obj = { hash: hash, answers: answers };
    if (sensor_form != undefined) obj['sensor_form'] = sensor_form;
    this.offline_answers.push(obj);
    // this.updateLocalData(this.offline_answers);
  }

  getImgBlob(url): Promise<Blob> {
    return firstValueFrom(this.http.get(url, { responseType: 'blob' }));
  }
}

